import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  count: {
    siteCount: 0,
    equipmentCount: 0,
    structureCount: 0,
    pipelineCount: 0,
    inspectionCount: 0,
    assetCheckCount: 0,
    workOrderCount: 0,
    inspectionFormCount: 0,
    syncedInspectionCount: 0,
    syncedWorkOrdersCount: 0,
    syncedHSECount: 0
  },
  refreshModalObject: null,
  idToStartSync: null
};
export const mobileSyncCountSlice = createSlice({
  name: 'mobileSyncCount',
  initialState,
  reducers: {
    setMobileSyncCount: (state, action) => {
      const { refreshModalObject, count } = action.payload;
      state.refreshModalObject = refreshModalObject;
      state.count = count;
    },
    setIdToStartSync: (state, action) => {
      state.idToStartSync = action.payload;
    }
  }
});

const mobileSyncReducer = mobileSyncCountSlice.reducer;

export const mobileSyncActions = mobileSyncCountSlice.actions;
export default mobileSyncReducer;
